import { CardTypeDTO } from "../../generated/api";

export const GET_CARD_TYPES = "GET_CARD_TYPES";
export const GET_ALL_CARD_TYPES = "GET_ALL_CARD_TYPES";
export const ADD_CARD_TYPE = "ADD_CARD_TYPE";
export const DELETE_CARD_TYPE = "DELETE_CARD_TYPE";
export const SET_ALL_CARD_TYPES = "SET_ALL_CARD_TYPES";
export const GET_AVAILABLE_CARD_TYPES = "GET_AVAILABLE_CARD_TYPES";
const SET_CARD_TYPES = "SET_CARD_TYPES";
export const UPDATE_CARD_TYPE_CONFIGURATIONS =
  "UPDATE_CARD_TYPE_CONFIGURATIONS";
export const GET_CARD_TYPE_CONFIGURATIONS = "GET_CARD_TYPE_CONFIGURATIONS";
export const SET_CARD_TYPE_CONFIGURATIONS = "SET_CARD_TYPE_CONFIGURATIONS";

export const setCardTypes = (cardTypes: CardTypeDTO[]) => ({
  type: SET_CARD_TYPES,
  cardTypes,
});

export const setAllCardTypes = (allCardTypes: CardTypeDTO[]) => ({
  type: SET_ALL_CARD_TYPES,
  allCardTypes,
});

export const getCardTypeConfigurations = () => ({
  type: GET_CARD_TYPE_CONFIGURATIONS,
});

export const setCardTypeConfigurations = (cardTypeConfig: any) => ({
  type: SET_CARD_TYPE_CONFIGURATIONS,
  cardTypeConfig,
});

const initialState = {
  cardTypes: null,
};

export const cardTypesReducer = (state = initialState, action: any) => {
  const { cardTypeConfig } = action;
  switch (action.type) {
    case SET_CARD_TYPES:
      const { cardTypes } = action;
      return { ...state, cardTypes };
    case SET_ALL_CARD_TYPES:
      const { allCardTypes } = action;
      return { ...state, allCardTypes };
    case SET_CARD_TYPE_CONFIGURATIONS:
      return { ...state, cardTypeConfig };
    default:
      return state;
  }
};
